import Main from "/canvas/main.js";

export default function(e) {
    Main.canvas.classList.remove("cursorCopy");
}